import React from "react";
import styled from "styled-components";
import closeIcon from "../../assets/close-circle.svg";

const Overlay = styled.div`
  position: fixed;
  width: 100%;
  height: 100%;
  padding: 0;
  border: none;
  top: 0;
  left: 0;
  z-index: 900;
  background-color: rgba(6, 41, 85, 0.7);
`;

const NoScrollDiv = styled.div`
  position: relative;
  overflow: hidden;
  width: 100%;
  height: 100%;
`;

const ModalWrapper = styled.div`
  padding: 48px;
  border-radius: 16px;
  box-shadow: 0 6px 20px 0 rgba(36, 45, 65, 0.1);
  background-color: #fff;
  width: 800px;
  position: fixed;
  z-index: 999;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  text-align: left;
  cursor: default;
  @media (max-width: 768px) {
    width: 100vw;
    padding: 20px 16px;
    top: 54%;
  }
`;

const LinksDiv = styled.div`
  display: flex;
  flex-direction: column;
  & li {
    color: #242d41;
    margin-bottom: 8px;
  }
  & a {
    color: #3382e6;
  }
`;

const StyledCloseButton = styled.button`
  background-color: transparent;
  border: none;
  padding: 0;
  width: 28px;
  height: 29px;
  align-items: flex-start;
  flex-shrink: 0;
  cursor: pointer;
  &:focus {
    outline: none;
  }
  img {
    width: 28px;
    height: 29px;
  }
`;

const HeaderWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
`;

const ConfirmationModal = ({ handleClose }) => {
  return (
    <Overlay onClick={handleClose} data-backdrop="false">
      <NoScrollDiv>
        <ModalWrapper onClick={(e) => e.stopPropagation()}>
          <div>
            <HeaderWrapper>
              <h5>Thank you for requesting a trial with us</h5>
              <StyledCloseButton onClick={handleClose}>
                <img src={closeIcon} alt="close icon" />
              </StyledCloseButton>
            </HeaderWrapper>
            <p>
              One of our sales representatives will be in touch with you shortly
              to set up your trial account. In the meantime please feel free to
              explore our full line of aviation products:
            </p>
            <LinksDiv>
              <ul>
                <li>
                  <a href="https://www.trustflight.com/centrik/">
                    Centrik SMS/QMS
                  </a>
                </li>
                <li>
                  <a href="https://www.trustflight.com/techlog/">
                    Electronic Tech Log
                  </a>
                </li>
                <li>
                  <a href="https://www.trustflight.com/reliability-analytics/">
                    Reliability Analytics
                  </a>
                </li>
              </ul>
            </LinksDiv>
          </div>
        </ModalWrapper>
      </NoScrollDiv>
    </Overlay>
  );
};

export default ConfirmationModal;
